import { connect } from 'react-redux'

import { operationRunKlarnaMonthlyInvoiceOperation } from '../../duck/operations'
import selectors from '../../duck/selectors'
import MonthlyInvoiceCardComponent from './MonthlyInvoiceCard.component'

const mapStateToProps = (state, { invoiceId }): any => {
  const invoice = selectors.getMonthlyInvoiceById(invoiceId, state)
  return { invoice }
}

const mapDispatchToProps = (dispatch): any => {
  const runKlarnaMonthlyInvoiceOperation = (token, invoiceId): any =>
    dispatch(operationRunKlarnaMonthlyInvoiceOperation(token, invoiceId))

  return { runKlarnaMonthlyInvoiceOperation }
}

export default connect(mapStateToProps, mapDispatchToProps)(MonthlyInvoiceCardComponent)
